export default __webpack_public_path__ + "6856d674e1e02e26fcabedcf2d50c763.png";